// extracted by mini-css-extract-plugin
export default {"card":"TalkCard_card__SllIA","cardImage":"TalkCard_cardImage__JTbad"};